import { SuspendModificationReason } from "../const/suspend-modification-reason";

export default {
  pinned: false,
  isDemo: false,
  isMobile: false,
  trackerId: "",
  appId: "",
  timezone: "",
  user: {
    isDev: false,
    isPartner: false,
    canSetIsDev: false,
    firstName: "",
    lastName: "",
    name: "",
    avatar: "",
    lang: "",
    email: "",
    agentId: "",
    currency: "",
    companyUrl: "",
    isEmailVerified: "",
    isSupport: false,
    subdomain: "",
    isMfaEnabled: false,
    roles: {
      ROLE_AGENT: false,
      ROLE_SUPER_AGENT: false,
      ROLE_INBOX: false,
      ROLE_DB: false,
      ROLE_SETTINGS: false,
      ROLE_ENGAGEMENT: false,
      ROLE_ONSITE: false,
      ROLE_ADVERTISEMENT: false,
      ROLE_REPORTS: false,
      ROLE_CRM: false,
      ROLE_LOGS: false,
      ROLE_PERMISSIONS: false,
    },
    trackers: [],
  },
  tracker: {
    configuration: {},
    lifecycle: {
      isSuspended: false,
      suspendModificationReasonId: SuspendModificationReason.None,
    },
    platform: "",
  },
  layout: {
    isLoadingOverlayVisible: true,
  },
};
